<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="1100px" scrollable>
            <v-card :loading="isLoading ? 'white' : null">
                <v-card-title class="primary white--text">
                    <span
                        >{{ plannedTask.plant ? plannedTask.plant.name : "" }}
                    </span>
                    <v-spacer />
                    <span v-if="plannedTask.growthStartDate">
                        {{ plannedTask.growthStartDate | moment("YYYY-[W]WW") }}</span
                    >
                    <v-spacer></v-spacer>
                    <span v-if="plannedTask.quantity"
                        >+{{ plannedTask.quantity }}</span
                    >
                    <v-spacer />
                    <v-btn icon dark @click="closeMainDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <div class="pa-3">
                    <v-row align="center" class="mx-0">
                        <v-col cols="12">
                            <div id="chart">
                                <apexchart
                                    type="bar"
                                    height="200"
                                    :options="chartOptions"
                                    :series="series"
                                ></apexchart>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <slot name="footer"></slot>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "planned-task-space-chart-dialog",
    props: ["dialog"],
    components: {
        apexchart: VueApexCharts
    },

    data: function() {
        return {
            isLoading: false,

            plannedTask: {},

            series: [],

            chartOptions: {
                chart: {
                    id: "planned-task-space-chart",
                    type: "bar",
                    height: 200,
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    // events: {
                    //     dataPointSelection: (event, chartContext, config) => {
                    //         console.log(event, chartContext, config);

                    //         this.$emit(
                    //             "week-selected",
                    //             config.dataPointIndex + 1
                    //         );
                    //     }
                    // },
                    animations: {
                        enabled: false
                    }
                },
                grid: {
                    show: false
                },
                xaxis: {
                    // tickPlacement: 'on',
                    type: "categories"
                },
                yaxis: {
                    labels: {
                        show: false,
                        formatter: function(val) {
                            return val.toFixed(0);
                        }
                    },
                    title: {
                        text: "m2"
                    },
                    max: 2000 //default value, will be updated by greenhouse total space
                },
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ["#333"]
                    },
                    offsetY: -20
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        dataLabels: {
                            position: "top"
                        }
                    }
                },
                colors: ["#00E396", "#FEB018"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: true,
                        formatter: value => {
                            return moment(value).format("YYYY-W");
                        }
                    },
                    y: {
                        formatter: value => {
                            return value + " m2";
                        }
                    }
                }
            }
        };
    },
    watch: {},
    computed: {},
    created() {},
    methods: {
        getPlannedTaskSpace(plannedTaskNodeId) {
            // console.log(this.greenhouseNodeId, this.taskYear);

            if (!plannedTaskNodeId) {
                return;
            }

            this.isLoading = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query plannedTask($id: ID!) {
                            plannedTask(id: $id) {
                                id
                                growthStartDate
                                quantity
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                color {
                                    id
                                    color
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                plannedTaskPhaseByWeekSet {
                                    edges {
                                        node {
                                            id
                                            phaseNo
                                            phaseYear
                                            phaseWeek
                                            numPlantsPerM2
                                            isSalesPhase
                                            spaceM2
                                            weekStartDate
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        id: plannedTaskNodeId
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // Result
                    // console.log(response.data);
                    // console.log(response.data.updateSalesOrderNote.salesOrder.note);

                    // console.log(this.chartOptions);

                    this.plannedTask = response.data.plannedTask;

                    const _weekStartDates = response.data.plannedTask.plannedTaskPhaseByWeekSet.edges.map(
                        item => {
                            return item.node.weekStartDate;
                        }
                    );

                    const _growingSpaceArray = response.data.plannedTask.plannedTaskPhaseByWeekSet.edges.map(
                        item => {
                            return item.node.isSalesPhase
                                ? 0
                                : item.node.spaceM2;
                        }
                    );

                    const _salesSpaceArray = response.data.plannedTask.plannedTaskPhaseByWeekSet.edges.map(
                        item => {
                            return item.node.isSalesPhase
                                ? item.node.spaceM2
                                : 0;
                        }
                    );

                    // console.log(_growingSpace);
                    // console.log(_salesSpace);

                    var _totalSpaceArray = _weekStartDates.map((val, index) => {
                        // console.log(item - 1);

                        return (
                            _growingSpaceArray[index] + _salesSpaceArray[index]
                        );
                    });

                    // _totalSpaceArray.push(
                    //     response.data.greenhouse.totalSpaceM2
                    // );

                    // console.log(_totalSpaceArray);

                    const _maxSeriesValue = Math.max(..._totalSpaceArray);

                    // console.log(_maxSeriesValue);

                    this.chartOptions = {
                        ...this.chartOptions,
                        ...{
                            yaxis: {
                                labels: {
                                    show: false,
                                    formatter: function(val) {
                                        return val.toFixed(0);
                                    }
                                },
                                title: {
                                    text: "m2"
                                },
                                max: _maxSeriesValue //default value, will be updated by greenhouse total space
                            }
                        },
                        ...{
                            xaxis: {
                                type: "categories",
                                categories: _weekStartDates,
                                labels: {
                                    formatter: function(value, timestamp) {
                                        return moment(timestamp).format(
                                            "YYYY-W"
                                        ); // The formatter function overrides format property
                                    }
                                }
                            }
                        }
                    };

                    this.series = [
                        { name: "Growing", data: _growingSpaceArray },
                        { name: "Sales", data: _salesSpaceArray }
                    ];

                    // // add growing space
                    // const growingSpace = response.data.greenhouse.greenhousePlannedSpaceSet.edges.map(
                    //     (item) => {
                    //         return {
                    //             name: "Growing",
                    //             data: [
                    //                 moment(item.node.growthStartDate).isoWeek(),
                    //                 moment(item.node.growthStartDate)
                    //                     .add(item.node.totalGrowthWeeks, "week")
                    //                     .isoWeek()
                    //             ]
                    //         };
                    //     }
                    // );
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoading = false;
                });
        },

        closeMainDialog() {
            this.$emit("update:dialog", false);
            this.plannedTask = {};
            this.chartOptions = {};
            this.series = [];
        }
    }
};
</script>